export const ro_options = [
  { application: [], elementGroup: [], elementModel : [] },
  { application: [], elementGroup: [], elementModel : [] },
  { application: [], elementGroup: [], elementModel : [] },
  { application: [], elementGroup: [], elementModel : [] },
  { application: [], elementGroup: [], elementModel : [] },
  { application: [], elementGroup: [], elementModel : [] },
  { application: [], elementGroup: [], elementModel : [] },
  { application: [], elementGroup: [], elementModel : [] },
];

export const ro_element_dd = [
  { application: [], elementGroup: [], elementModel : [] },
  { application: [], elementGroup: [], elementModel : [] },
  { application: [], elementGroup: [], elementModel : [] },
  { application: [], elementGroup: [], elementModel : [] },
  { application: [], elementGroup: [], elementModel : [] },
  { application: [], elementGroup: [], elementModel : [] },
  { application: [], elementGroup: [], elementModel : [] },
  { application: [], elementGroup: [], elementModel : [] },
];

// AG-grid
// export const ro_element_dd = [
//   { application: ' ', elementGroup: ' ', elementModel : ' ' },
//   { application: ' ', elementGroup: ' ', elementModel : ' ' },
//   { application: ' ', elementGroup: ' ', elementModel : ' ' },
//   { application: ' ', elementGroup: ' ', elementModel : ' ' },
//   { application: ' ', elementGroup: ' ', elementModel : ' ' },
//   { application: ' ', elementGroup: ' ', elementModel : ' ' },
//   { application: ' ', elementGroup: ' ', elementModel : ' ' },
//   { application: ' ', elementGroup: ' ', elementModel : ' ' },
// ];